export default __webpack_public_path__ + "static/media/section1-img2.11adb4f5.png";